import { Button, ConfigProvider, Grid } from 'antd';
import { useNavigate } from 'react-router';
import { Fragment } from 'react/jsx-runtime';
import { ButtonWithIcon } from '@/components/ui/ButtonWithIcon';
import { SvgIcon } from '@/components/icon';
import React, { CSSProperties, FC } from 'react';
import { ButtonProps } from 'antd/lib';

interface Props extends ButtonProps {
  mobileStyle?: CSSProperties;
  desktopStyle?: CSSProperties;
}

export const BackButton: FC<Props> = ({
  onClick,
  mobileStyle,
  desktopStyle,
}) => {
  const { lg } = Grid.useBreakpoint();
  const navigate = useNavigate();

  const handleClick = (
    e: React.MouseEvent<HTMLElement> | React.KeyboardEvent<HTMLElement>,
  ) => {
    if (onClick) {
      onClick(e as React.MouseEvent<HTMLElement>);
    } else {
      navigate(-1);
    }
  };

  const style: Record<'desktop' | 'mobile', CSSProperties> = {
    mobile: {
      display: 'flex',
      alignSelf: 'flex-start',
      alignItems: 'center',
      margin: '0 0 32px',
      justifyContent: 'center',
      ...mobileStyle,
    },
    desktop: {
      display: 'flex',
      margin: '0 0 24px',
      padding: 0,
      alignSelf: 'flex-start',
      alignItems: 'center',
      justifyContent: 'center',
      ...desktopStyle,
    },
  };

  return (
    <Fragment>
      {lg ? (
        <ConfigProvider
          theme={{
            components: {
              Button: {
                textHoverBg: 'transparent',
              },
            },
          }}
        >
          <Button
            icon={<SvgIcon type={'arrowLeftOutlined'} />}
            onClick={handleClick}
            style={style.desktop}
            type={'text'}
          >
            Back
          </Button>
        </ConfigProvider>
      ) : (
        <ButtonWithIcon
          style={style.mobile}
          onClick={handleClick}
          icon={<SvgIcon type={'arrowLeft'} />}
        />
      )}
    </Fragment>
  );
};
